import type { UploadRecordSource } from '@/api/uploadRecords';
import type { Translate } from '@/i18n/translate';

export type DeliverableType = 'package' | 'external_release';

export const DELIVERABLE_TYPE_LABELS: Record<string, { label: string; color: string }> = {
  package: { label: '底软交付物', color: 'blue' },
  external_release: { label: 'Momenta释放产物包', color: 'purple' },
};

export const SOURCE_LABELS: Record<string, { label: string; color: string }> = {
  bsp: { label: 'BSP', color: 'default' },
  api: { label: 'API', color: 'cyan' },
  bvp_bot: { label: 'BVP Bot', color: 'gold' },
  rpa: { label: 'RPA', color: 'magenta' },
};

export const SOURCE_FILTERS = Object.entries(SOURCE_LABELS).map(([value, { label }]) => ({
  text: label,
  value,
}));

type LabelMeta = { label: string; color: string };

const translateLabels = (
  labels: Record<string, LabelMeta>,
  t: Translate
): Record<string, LabelMeta> =>
  Object.fromEntries(
    Object.entries(labels).map(([key, meta]) => [key, { ...meta, label: t(meta.label) }])
  );

export const getDeliverableTypeLabels = (t: Translate) => translateLabels(DELIVERABLE_TYPE_LABELS, t);

export const getSourceLabels = (t: Translate) => translateLabels(SOURCE_LABELS, t);

export const getSourceFilters = (t: Translate) =>
  Object.entries(getSourceLabels(t)).map(([value, { label }]) => ({ text: label, value }));

/** 看板按交付类型展示各自的来源；饼图需要十六进制色，和 Tag 的预设色对应。 */
export const SOURCE_HEX_COLORS: Record<UploadRecordSource, string> = {
  bsp: '#8c8c8c',
  api: '#13c2c2',
  bvp_bot: '#faad14',
  rpa: '#eb2f96',
};

export const sourcesForDeliverableType = (type: DeliverableType): UploadRecordSource[] =>
  type === 'package' ? ['bsp', 'api', 'bvp_bot'] : ['bsp', 'rpa'];
